import { useFormContext } from 'react-hook-form'

import { SubmitButton } from '@/components/Forms'
import { useModal } from '@/components/Modal'
import { Button } from '@/ui/Button'
import styles from '../MechanicalInformationModal.module.scss'
import { MECHANICAL_INFORMATION_FORM_FIELDS } from '../../constant'
import { BusAuthorizedStatus } from '@/types/mechanicalInformation'
import { Log } from '@/types/logs'
import { useDeleteMechanicalInformation } from '../../api/useDeleteMechanicalInformation'

interface Props {
    isPending: boolean
}

type ModalProps = {
    log: Log
    deleteCallback?: () => void
}

export const Actions = ({ isPending }: Props) => {
    const {
        watch,
        formState: { isValid },
    } = useFormContext()
    const { props } = useModal<ModalProps>()

    const { handleDeleteMechanicalInformation } = useDeleteMechanicalInformation({
        log: props?.log,
        callback: props?.deleteCallback,
    })

    const busAuthorizedStatus = watch(MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus)

    const needToShowDescription =
        typeof busAuthorizedStatus === 'string' && busAuthorizedStatus === BusAuthorizedStatus.SubstitutionRequired
    const isDeleteAvailable = !props?.log.codeTypeReasonInfo?.isMechanicalInfoRequired && !!props?.log.mechanicalInfo

    return (
        <div className={styles.actions}>
            {isDeleteAvailable && (
                <Button variant="transparent" onClick={handleDeleteMechanicalInformation}>
                    Delete information
                </Button>
            )}
            <div className={styles.saveButtonWrapper}>
                <SubmitButton rounded disabled={!isValid || isPending}>
                    Save information
                </SubmitButton>
                {needToShowDescription && (
                    <span className={styles.description}>Log entries will be created with bus substitution</span>
                )}
            </div>
        </div>
    )
}
